export enum KycStatusEnum {
  UNREQUESTED = 1,
  REQUIRED = 2,
  PASSED = 3,
  FAILED = 4,
  STARTED = 5,
  VOLUNTEERED = 6,
}
